const mainRequest = (url, opts) => {
  return fetch(url, {
    ...opts,
    headers: {
      Accept: 'application/json',
      'content-type': 'application/json'
    }
  })
    .then((r) =>
      r.json().then((data) => {
        if (r.status === 404)
          return (window.location = '/ddjj/confirmacion-cuit')
        return { status: r.status, content: data }
      })
    )
    .catch((err) => console.log(err))
}

function emptyPromise() {
  return new Promise((resolve, _) => {
    resolve(false)
  }).then((notOk) => {
    return notOk
  })
}

function requestGetPasoActual() {
  return mainRequest('/ddjj/api/paso-actual')
}

function requestCuitEInfo() {
  return mainRequest('/ddjj/api/paso-uno/info')
}

function requestGetMontoFecha() {
  return mainRequest('/ddjj/api/terminos')
}

function requestAceptarTerminos() {
  return mainRequest('/ddjj/api/terminos', { method: 'POST' })
}

function requestTraerInfoPasoCuatro() {
  return mainRequest('/ddjj/api/paso-cuatro')
}

function requestTraerInfoActividadComercial() {
  return mainRequest('/ddjj/api/actividad-comercial')
}

function requestGuardarDatosComercial(datos) {
  return mainRequest('/ddjj/api/actividad-comercial', {
    method: 'post',
    body: datos
  })
}

function traerDatosContribuyente() {
  return mainRequest('/ddjj/api/datos-contribuyente')
}

function guardarDatosContribuyente(params) {
  return mainRequest('/ddjj/api/datos-contribuyente', {
    method: 'post',
    body: params
  })
}

function requestTraerInfoUsuario() {
  return mainRequest('/ddjj/api/info-usuario')
}

function guardarPagos(params) {
  return mainRequest('/ddjj/api/datos-pagos', {
    method: 'post',
    body: params
  })
}

function traerDatosEpagos() {
  return mainRequest('/ddjj/api/epagos')
}

function traerDatosIngresoCuit(cuit = undefined) {
  return mainRequest(`/ddjj/api/ingreso/cuit${cuit ? '?cuit=' + cuit : ''}`)
}

function guardarIngresoCuit(uri, params) {
  return mainRequest(uri, {
    method: 'post',
    body: params
  })
}

function requestDeterminacionTasaPrecarga() {
  return mainRequest('/ddjj/api/determinacion-tasa/precarga')
}

function requestDeterminacionTasa() {
  return mainRequest('/ddjj/api/determinacion-tasa')
}

function requestConfirmarDDJJ() {
  return mainRequest('/ddjj/api/emision-ddjj', { method: 'POST' })
}

function storeDeterminacionTasa(datos) {
  return mainRequest('/ddjj/api/determinacion-tasa', {
    method: 'POST',
    body: datos
  })
}

function getDataEPagosDDBB() {
  return mainRequest('/ddjj/api/epagos/get-data-epagos-bbdd', {
    method: 'POST'
  })
}

function validarCuitContribuyente(cuit) {
  return mainRequest('/ddjj/alta/api/verificacion-persona-juridica', {
    method: 'POST',
    body: cuit
  })
}

export {
  mainRequest,
  emptyPromise,
  requestGetPasoActual,
  requestTraerInfoActividadComercial,
  requestGuardarDatosComercial,
  requestCuitEInfo,
  requestGetMontoFecha,
  requestAceptarTerminos,
  requestTraerInfoPasoCuatro,
  requestTraerInfoUsuario,
  guardarDatosContribuyente,
  traerDatosContribuyente,
  guardarPagos,
  traerDatosEpagos,
  traerDatosIngresoCuit,
  guardarIngresoCuit,
  requestDeterminacionTasaPrecarga,
  requestDeterminacionTasa,
  storeDeterminacionTasa,
  requestConfirmarDDJJ,
  getDataEPagosDDBB,
  validarCuitContribuyente
}
